module.exports = __webpack_public_path__ + "static/media/sgx_animation.9761b243.mp4";